"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricHandler = void 0;
var handler_js_1 = require("./handler.js");
Object.defineProperty(exports, "MetricHandler", { enumerable: true, get: function () { return handler_js_1.MetricHandler; } });
//# sourceMappingURL=index.js.map